// extracted by mini-css-extract-plugin
export default {"videoIFrame":"TheClinic_videoIFrame__f+71y"};